export const Endpoints = {
    wpLocations: 'https://pr.uoc.gr/wp-json/uoc/v1/locations',
    plots: 'https://services8.arcgis.com/EmWvvrOhuQfw1gSw/arcgis/rest/services/uoc_voutes_WFL1/FeatureServer/6',
    buildings: 'https://services8.arcgis.com/EmWvvrOhuQfw1gSw/arcgis/rest/services/uoc_voutes_WFL1/FeatureServer/5',
    paths: 'https://services8.arcgis.com/EmWvvrOhuQfw1gSw/arcgis/rest/services/uoc_voutes_WFL1/FeatureServer/1',
    pois: 'https://services8.arcgis.com/EmWvvrOhuQfw1gSw/arcgis/rest/services/uoc_pois/FeatureServer/0'
};

export const UI_IDS = {
    modalId: 'map-modal-container',
    mapContainerId: 'leaflet-map-canvas',
    uiContainerId: 'wheelmap-filters'
};
